export default {
  LOAD_CLAIM_REVIEW_LIST_START: 'LoadClaimReviewListStart',
  LOAD_CLAIM_REVIEW_LIST_END: 'LoadClaimReviewListEnd',
  FILTER_CLAIM_REVIEW_LIST: 'FilterClaimReviewList',
  SORT_CLAIM_REVIEW_LIST: 'SortClaimReviewList'
};
